import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";

//import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
//import CardContent from "@material-ui/core/CardContent";
//import CardHeader from "@material-ui/core/CardHeader";
//import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
//import InputAdornment from "@material-ui/core/InputAdornment";


// @material-ui/icons components
//import School from "@material-ui/icons/School";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";


import { Typography } from "@material-ui/core";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function Delete() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [usernames, setusernames] = useState([]);
  const [batches, setbatches] = useState([]);
  const [alertText, setalertText] = useState("");
  const [loading, setLoading] = useState(true);
  const [form, setform] = useState({
    studentId: 0,
    batchId: 0,
  
  });

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };



  const fetchBatches = async () => {
    var token = localStorage.getItem("token");
    try {
      const res = await fetch("https://server.thelanofficial.com/Get-Batches", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.json();

      if (data.valid === false) {
        return;
      } else if (data.valid === true) {
        setbatches(data.result);

        setLoading(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

 


  const fetchUsernames = async () => {
    var token = localStorage.getItem("token");
    try {
      const res = await fetch("https://server.thelanofficial.com/Get-Users-All", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await res.json();

      if (data.valid === false) {
        return;
      } else if (data.valid === true) {
        setusernames(data.users);

        setLoading(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const ChangeCLick = () => {
    if (["studentId","batchId"].some((field) => form[field] === "")) {
      setalertText("please fill all the fields");
      return;
    }

    var token = localStorage.getItem("token");

    const fetchCreate = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/Enroll-Student", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
          batchId: form.batchId,
            studentId: form.studentId,
            token,
          }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {
          setform((prev) => ({
            ...prev,
            [form.password]: "",
          }));
          setalertText(data.message);
          fetchUsernames();
          fetchBatches();
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchCreate();
   
  };

  useEffect(() => {
    var token = localStorage.getItem("token");

    const fetchData = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/validate-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchData();
    fetchUsernames();
    fetchBatches();
  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center">
        <Grid >
        <Box
          color={theme.palette.gray[600]}
          textAlign="center"
          marginBottom="1.5rem"
          marginTop=".5rem"
          fontSize="1rem"
        >
          <Box fontSize="80%" fontWeight="400" component="small">
            Select the student and then select the Batch
          </Box>
        </Box>
        <Box style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <FormControl variant="outlined" fullWidth>
            {loading ? (
              <Typography>Loading...</Typography>
            ) : (
              <Select
                placeholder="ROLE"
                name="studentId"
                defaultValue=""
                onChange={handleChange}
                IconComponent={KeyboardArrowDown}
              >
                <MenuItem value="" disabled>
                  Select a student
                </MenuItem>
                {
                usernames.map((key, index) =>
                  usernames[index].role === "student" ? (
                    <MenuItem
                      key={index}
                      value={usernames[index].user_id}
                    >
                     {usernames[index].user_id} - {usernames[index].username} - {usernames[index].first_name}  {usernames[index].last_name}
                    </MenuItem>
                  ) : null
                )}
              </Select>
            )}
          </FormControl>

          <FormControl variant="outlined" fullWidth>
            {loading ? (
              <Typography>Loading...</Typography>
            ) : (
              <Select
                placeholder="ROLE"
                name="batchId"
                defaultValue=""
                onChange={handleChange}
                IconComponent={KeyboardArrowDown}
              >
                <MenuItem value="" disabled>
                  Select a batch
                </MenuItem>
                {batches.map((key, index) =>
                 
                    <MenuItem
                      key={index}
                      value={batches[index].batch_id}
                    >
                    {batches[index].batch_id} - {batches[index].batch_name} -  {new Date(batches[index].created_at).toLocaleDateString()}
                    </MenuItem>
                 
                )}
              </Select>
            )}
          </FormControl>
          
        </Box>
        
       
        <Box
          fontStyle="italic"
          fontSize="1rem"
          color={theme.palette.gray[600]}
          marginBottom=".5rem"
        >
          <Box component="small" fontSize="80%">
            <Box
              component="span"
              fontWeight="700"
              color={theme.palette.success.main}
            />
          </Box>
        </Box>
        <Typography
          style={{
            color: alertText === "Student enrolled" ? "green" : "red",
            fontSize: "10px",
          }}
        >
          {alertText}
        </Typography>
        <Box textAlign="center" marginTop="6rem" marginBottom="1.5rem">
          <Button
            onClick={ChangeCLick}
            variant="contained"
            classes={{ root: classes.buttonContainedInfo }}
          >
            Enroll Student
          </Button>
        </Box>


          
          <Grid container component={Box} marginTop="1rem">
            <Grid item xs={6} component={Box} textAlign="left"></Grid>
            <Grid item xs={6} component={Box} textAlign="right"></Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Delete;
